<template>
  <div class="detail">
    <div class="content">
      <div v-if="isBeginner">
        <div class="question question-beginner">
          <div class="question-dsc">{{ detail.title || '' }}</div>
        </div>
        <div class="answer">
          <div class="answer-dsc" v-html="detail.contents"></div>
        </div>
      </div>
      <div v-else>
        <div class="question" >
          <div class="title">问题：</div>
          <div class="question-dsc">{{ detail.remark || '' }}</div>
        </div>
        <div class="answer">
          <div class="title mt-45">回答：</div>
          <div class="answer-dsc" v-html="detail.contents"></div>
        </div>
      </div>
    </div>
    <div class="evaluation">
      <div class="header">
        <div class="title">访问此篇文档：</div>
        <div class="num">{{ detail.viewsNumber || 0 }}</div>
      </div>
      <div class="bottom">
        <div class="title">评价此篇文档：</div>
        <div class="btns">
          <img :src="item.icon" alt="" @click="handleHelpful(item)" v-for="item in btnsList" :key="item.isHelpful">
        </div>
      </div>
    </div>
  </div>
</template>

<script>;
import Cookies from 'js-cookie';
import { mapActions, mapState } from 'vuex';
export default {
  name: 'QuestionDetail',
  data() {
    return {
      detail: {},//问题详情
      useful: false, //标记该问题是否反馈过
      btnsList:[
        {
          text: '有帮助',
          icon: require('../../assets/images/client/evaluationUse.png'),
          isHelpful: 1
        },
        {
          text: '无帮助',
          icon: require('../../assets/images/client/evaluationUnuse.png'),
          isHelpful: 2
        }
      ]
    };
  },
  computed:{
    isBeginner(){
      return this.$route.query.type === 'beginner';
    }
  },
  mounted() {
    const { id, type } = this.$route.query;
    if(type === 'quesion'){
      // 问题详情
      this.getQuestionClientDetails(id);
    }else if(type === 'beginner'){
      // 新人入门内容详细信息
      this.getBeginnerInfoClientDetails(id);
    }
  },

  methods: {
    ...mapActions(['questionClientDetails', 'questionClientFeedback', 'beginnerInfoClientDetails', 'beginnerInfoClientFeedback']),
    // 评价
    handleHelpful(item){
      if (this.useful === true) {
          this.$message.info('您已反馈过，感谢反馈！');
          return;
      }
      this.useful = true;
      const { id, type } = this.$route.query;
      if(type === 'quesion'){
        // 问题详情
        this.questionClientFeedback({ id, action: item.isHelpful }).then(res=>{
          this.$message.success('评价成功');
        })
      }else if(type === 'beginner'){
        // 新人入门内容详细信息
        this.beginnerInfoClientFeedback({ id, action: item.isHelpful }).then(res=>{
          this.$message.success('评价成功');
        })
      }
    },
    //  问题详情
    getQuestionClientDetails(id){
      this.questionClientDetails({ id }).then(res=>{
        this.detail = res;
      })
    },
    // 新人入门内容详细信息
    getBeginnerInfoClientDetails(id){
      this.beginnerInfoClientDetails({ id }).then(res=>{
        this.detail = res;
      })
    },
  },
};
</script>

<style lang="sass" rel="stylesheet/scss" scoped>
.detail{
  min-height: 560px;
  width: 100%;
  display: flex;
  .content{
    background-color: #fff;
    width: calc(100% - 220px);
    margin-right: 20px;
    padding: 20px;
    .title{
      margin-bottom: 15px;
      font-size: 14px;
      color: #333;
      line-height: 14px;
      font-weight: bold;
    }
    .mt-45{
      margin-top: 45px;
    }
    .question{
      overflow: hidden;
      &-dsc{
        font-size: 20px;
        color: #333;
        font-weight: bold;
        line-height: 30px;
      }
    }
    .answer{
      overflow: hidden;
    }
    .question-beginner{
      margin-bottom: 60px;
    }
  }
  .evaluation{
    width: 200px;
    background-color: #fff;
    padding: 20px 20px 30px 20px;
    position: relative;
    .title{
      margin: 20px auto 10px;
      font-size: 14px;
      color: #999;
      line-height: 14px;
    }
    .header{
      height: 90px;
      .num{
        font-size: 22px;
        color: #333;
        font-weight: bold;
      }
    }
    .bottom{
      position: absolute;
      bottom: 30px;
      left: 20px;
      .btns{
        img{
          display: block;
          width: 160px;
          height: 33px;
          object-fit: contain;
          margin-bottom: 10px;
          cursor: pointer;
        }
        .img:last-child{
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// QuestionDetail.vue?0eb0c54a